import { render, staticRenderFns } from "./ClockControlWidget.vue?vue&type=template&id=77db7240&scoped=true&"
import script from "./ClockControlWidget.vue?vue&type=script&lang=js&"
export * from "./ClockControlWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77db7240",
  null
  
)

export default component.exports